import { ApiClient, apiClient } from "../../../core/api_client";
import { generateCrudRepoFactory } from "../../../core/crud";
import { ICRUDRepo } from "../../../core/models";
import { expenseFromJson, expenseToJson, IExpense, IExpenseForm } from "./entities";

interface IExpenseRepo extends ICRUDRepo<IExpense, IExpenseForm> {}

const URL = "v1/expense";

const ExpenseRepoImplFactory = (apiClient: ApiClient): IExpenseRepo => {
  const r: IExpenseRepo = {
    ...generateCrudRepoFactory<IExpense, IExpenseForm>(apiClient, URL, expenseFromJson, expenseToJson),
  };

  return r;
};

export const ExpenseRepoImpl = ExpenseRepoImplFactory(apiClient);
